export const importAllImages = (requireContext) => {
    return requireContext.keys().map(requireContext);
  };
  
  export const pmneProjectImages = importAllImages(
    require.context('../assets/images/pmneProject', false, /\.(png|jpe?g|svg)$/)
  );

  export const datTbProjectImages = importAllImages(
    require.context('../assets/images/datTbProject', false, /\.(png|jpe?g|svg)$/)
  );
  

  export const geoDataVisualisationToolProjectImages = importAllImages(
    require.context('../assets/images/geoDataVisualisationToolProject', false, /\.(png|jpe?g|svg)$/)
  );
  

  